/**
 * Dépense payée en espèces ou par carte.
 *
 * Le patron paie un café en espèces, l'essence à la carte : il le note sur la
 * dépense, et la lecture du ticket le propose d'elle-même quand le ticket
 * l'imprime (« Espèces », « Rendu », « Visa », « TWINT »…).
 */

/** Les deux moyens de paiement, dans l'ordre des boutons. */
export const PAIEMENTS = [
  { k: 'especes', lib: '💵 Espèces' },
  { k: 'carte', lib: '💳 Carte' },
  { k: 'banque', lib: '🏦 Banque' },
];

/** Libellé court d'un moyen de paiement, ou '' s'il n'est pas dit. */
export const libellePaiement = (k) => PAIEMENTS.find((p) => p.k === k)?.lib || '';

// L'argent rendu ou la monnaie ne s'imprime que pour des espèces.
const ESPECES =
  /\b(esp[eè]ces|cash|comptant|bargeld|barzahlung|contanti|contante|efectivo|rendu|monnaie rendue|r[uü]ckgeld|wechselgeld)\b|^\s*bar\b(?=.*\d)/i;
const CARTE =
  /\b(carte|cartes? bancaire|card|karte|visa|master\s?card|maestro|v\s?pay|postfinance|debit|d[ée]bit|amex|american express|twint|apple\s?pay|google\s?pay|samsung\s?pay|sans contact|contactless|kontaktlos|nfc|carta|bancomat|ec[- ]karte|girocard)\b/i;

/**
 * Le moyen de paiement imprimé sur un ticket.
 *
 * Les premières lignes (le nom du commerce, « Café-Bar du Lac ») ne comptent
 * pas : seul le pied du ticket dit comment il a été payé.
 *
 * @param {string[]} lignes lignes du ticket
 * @returns {'especes'|'carte'|null} le moyen lu, ou null
 */
export function paiementDuTicket(lignes) {
  const pied = (lignes || []).slice(Math.min(3, Math.floor((lignes || []).length / 3)));
  let especes = false;
  let carte = false;
  for (const l of pied) {
    if (ESPECES.test(l)) especes = true;
    // « Carte de fidélité », « carte cadeau » : pas le paiement.
    if (CARTE.test(l) && !/fid[ée]lit|cadeau|geschenk|cumulus|bonus|punkte|points/i.test(l))
      carte = true;
  }
  if (carte && !especes) return 'carte';
  if (especes && !carte) return 'especes';
  return null;
}
